import { render, staticRenderFns } from "./UpsellItemsPage.vue?vue&type=template&id=03deb3d3&scoped=true&"
import script from "./UpsellItemsPage.vue?vue&type=script&lang=js&"
export * from "./UpsellItemsPage.vue?vue&type=script&lang=js&"
import style0 from "./UpsellItemsPage.vue?vue&type=style&index=0&id=03deb3d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03deb3d3",
  null
  
)

export default component.exports